
eval("define(\'text!data.json\',[],function () { return \'{\\n    \"htmlAttrs\": {\\n        \"href\":         { \"attribOption\": [] },\\n        \"src\":          { \"attribOption\": [] }\\n    }\\n}\\n\';});\n\n//# sourceURL=/text!data.json");

